type ExclamationIconProps = {
  color: string;
};

export const ExclamationIcon = ({ color }: ExclamationIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 17"
  >
    <g data-name="Layer 2">
      <g data-name="invisible box">
        <path data-name="Rectangle 7293" fill="none" d="M0 0h17v17H0z" />
      </g>
      <g data-name="Q3 icons">
        <g data-name="Groupe 18996" transform="translate(.718 .731)">
          <path
            data-name="Tracé 13110"
            d="M10.037 18.074a8 8 0 1 0-5.694-2.343 8.037 8.037 0 0 0 5.694 2.343zm0-14.612a6.576 6.576 0 1 1-6.576 6.576 6.576 6.576 0 0 1 6.576-6.576z"
            transform="translate(-2 -2)"
            fill={color}
          />
          <path
            data-name="Tracé 13111"
            d="M23 17.845c.552 0 1-.327 1-.731v-4.383c0-.4-.448-.731-1-.731s-1 .327-1 .731v4.384c0 .403.448.73 1 .73z"
            transform="translate(-14.718 -8.347)"
            fill={color}
          />
          <circle
            data-name="Ellipse 913"
            cx="1"
            cy="1"
            r="1"
            transform="translate(7.282 11.27)"
            fill={color}
          />
        </g>
      </g>
    </g>
  </svg>
);
